export default __webpack_public_path__ + "static/hero_servicios-b7e1c55e00899ae63d1ecd54a86aa4c6.jpg";